import { createTheme, ThemeOptions } from '@mui/material/styles';

// RITTEC CI Colors
const rittecColors = {
  petrol: '#1D8296',
  petrolLight: '#2BA3B9',
  petrolDark: '#156B7C',
  hellgrau: '#9DB0AC',
  dunkelgrau: '#1D252D',
  white: '#FFFFFF',
  black: '#000000',
};

const baseTheme: ThemeOptions = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: rittecColors.petrol,
      light: rittecColors.petrolLight,
      dark: rittecColors.petrolDark,
      contrastText: rittecColors.white,
    },
    secondary: {
      main: rittecColors.hellgrau,
      contrastText: rittecColors.dunkelgrau,
    },
    background: {
      default: '#F5F7F6',
      paper: rittecColors.white,
    },
    text: {
      primary: rittecColors.dunkelgrau,
      secondary: '#5A6A6E',
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: rittecColors.petrolLight,
      light: '#3CB8CE',
      dark: rittecColors.petrol,
      contrastText: rittecColors.white,
    },
    secondary: {
      main: rittecColors.hellgrau,
      contrastText: rittecColors.white,
    },
    background: {
      default: '#0D1117',
      paper: '#161B22',
    },
    text: {
      primary: '#E6EDF3',
      secondary: '#8B949E',
    },
  },
});

export { rittecColors };
